import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import BankBalanceModal from "../../../../../modals/yourAssets/BOA/BankBalanceModal";
import Typography from "@mui/material/Typography";
import { SecondaryButton } from "../../../../../common/Buttons";
import FormattedDate from "../../../../../utils/TabelDateFormat";

import {
  getAllUsersBA,
  getFile,
  updateUserBA,
} from "../../../../../services/yourAssets/BankBalancesServices";
import DeleteDataModal from "../../../../../modals/yourAssets/BOA/DeleteDataModal";
import toast, { Toaster } from "react-hot-toast";
import ImportData from "../ImportData";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../../../constants/constants";
import { updateAuditTrails } from "../../../../../services/auditTrails";
import ModifiedByToaster from "../../../../../common/ModifiedByToaster";
import {
  getClientIdFromLocalStorage,
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  changeUpdateFormat,
} from "../../../../../utils/Utilities";
import { useDispatch, useSelector } from "react-redux";
import FilePreviewModal from "../../../../yourAssets/BOA/FilePreviewModal";
import DeleteFileModal from "../../../../../modals/yourAssets/BOA/DeleteFileModal";
import { deleteUserMediaBOA } from "../../../../../services/yourAssets/CommonServices";
import { handleReloadFiles } from "../../../../../redux/slices/yourAssets/AssetsDocumentsSlice";

const Summary = (props) => {
  let clientId = getClientIdFromLocalStorage();
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const { next } = props;
  const [bankBalanceList, setBankBalanceList] = useState([]);
  const [checkChanges, setCheckChanges] = useState(false);
  const [newAccountFlag, setNewAccountFlag] = useState(false);
  const [showBankBalanceModal, setShowBankBalanceModal] = useState(false);
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [focusedFeild, setFocusedFeild] = useState({});
  const [selectedSubOwner, setSelectedSubOwner] = useState({});
  const [selectedSubOwnerIndex, setSelectedSubOwnerIndex] = useState("");
  const [accountTypeId, setAccountTypeId] = useState("");
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.bankBalances
  );
  const dispatch = useDispatch();
  const getAccountList = async () => {
    setBtnLoading(true);
    let result = await getAllUsersBA(id);

    if (result?.success) {
      let array = [];

      for (let i = 0; i < result?.payLoad.length; i++) {
        const elementI = result?.payLoad[i];
        let mainObj = {
          id: "",
          accountName: "",
          accountNumber: "",
          ownersData: [],
        };
        mainObj.id = elementI?.bankAccountId ? elementI?.bankAccountId : "";
        mainObj.accountName = elementI?.accountName;
        mainObj.accountNumber = elementI?.accountNumber;
        let obj = {
          nameOfOwner: elementI?.nameOfOwner,
          ownerShipPercentage: elementI?.ownerShipPercentage,
          accountBalance: elementI?.accountBalance,
          dateOfValue: elementI?.dateOfValue,
        };
        mainObj.ownersData.push(obj);
        for (let j = 0; j < elementI?.subBankAccounts.length; j++) {
          const elementJ = elementI?.subBankAccounts[j];
          let subObj = {
            nameOfOwner: elementJ?.nameOfOwner,
            ownerShipPercentage: elementJ?.ownerShipPercentage,
            accountBalance: elementJ?.accountBalance,
            dateOfValue: elementJ?.dateOfValue,
            id: elementJ?.subBankAccountId ? elementJ?.subBankAccountId : "",
            bankAccountId: elementI?.bankAccountId
              ? elementI.bankAccountId
              : "",
          };

          mainObj.ownersData.push(subObj);
        }

        array.push(mainObj);
      }
      setBankBalanceList(array);
    }
    setBtnLoading(false);
  };
  const handleUpdates = async (data) => {
    await updateAuditTrails(data, id);
  };
  useEffect(() => {
    setCheckChanges(false);
    getAccountList();
  }, [checkChanges]);
  useEffect(() => {
    setUpdatedIds(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[1] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[1]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[1] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[1]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[1] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[1]?.toLowerCase()
        )
        .map((item) => item)
    );
  }, []);
  const handleFinalSubmit = async () => {
    setBtnLoading(true);
    let array = [];
    let bankBalanceListClone = JSON.parse(JSON.stringify(bankBalanceList));
    for (let i = 0; i < bankBalanceListClone.length; i++) {
      const elementI = bankBalanceListClone[i];
      let mainObj = {
        bankAccountId: elementI.id?.length > 10 ? elementI.id : "",
        accountName: elementI.accountName,
        accountNumber: elementI.accountNumber,
        nameOfOwner: elementI.ownersData[0].nameOfOwner,
        ownerShipPercentage: elementI.ownersData[0].ownerShipPercentage,
        accountBalance: elementI.ownersData[0].accountBalance.toString(),
        dateOfValue: elementI.ownersData[0].dateOfValue,
        subBankAccounts: [],
      };

      elementI.ownersData.shift();
      for (let j = 0; j < elementI.ownersData.length; j++) {
        let elementJ = elementI.ownersData[j];
        elementJ.bankAccountId = elementI.id?.length > 10 ? elementJ.id : "";
        elementJ.subBankAccountId = elementJ.id?.length > 10 ? elementJ.id : "";

        delete elementJ.id;
      }
      mainObj.subBankAccounts = elementI.ownersData;
      array.push(mainObj);
    }
    let result;
    result = await updateUserBA(array, id);
    if (result?.success) {
      setCheckChanges(true);
      next();
    } else {
      toast.error(t(getKeyFromText(result?.message)));
    }
    setBtnLoading(false);
  };

  const reInitializeSelection = () => {
    setAccountTypeId("");
    setFocusedFeild({});
    setSelectedSubOwner({});
    setSelectedSubOwnerIndex("");
  };

  const handleAddSubOwner = (item, typeId, subOwner, subOwnerIndex) => {
    handleBankBalanceModalOpen();
    setAccountTypeId(typeId);
    setFocusedFeild(item);
    let obj = {
      accountName: item.accountName ? item.accountName : "",
      accountNumber: item.accountNumber ? item.accountNumber : "",
      nameOfOwner: subOwner.nameOfOwner ? subOwner.nameOfOwner : "",
      ownerShipPercentage: subOwner.ownerShipPercentage
        ? subOwner.ownerShipPercentage
        : "",
      accountBalance: subOwner.accountBalance ? subOwner.accountBalance : "",
      dateOfValue: subOwner.dateOfValue ? subOwner.dateOfValue : "",
    };

    setSelectedSubOwner(obj);
    setSelectedSubOwnerIndex(subOwnerIndex);
  };
  const handleDeleteSubOwner = (item, typeId, subOwner, subOwnerIndex) => {
    setDeleteDataModal(true);
    setAccountTypeId(typeId);
    setFocusedFeild(item);
    setSelectedSubOwner(subOwner);
    setSelectedSubOwnerIndex(subOwnerIndex);
  };
  const handleAddNewAccount = () => {
    setNewAccountFlag(true);
    handleBankBalanceModalOpen();
  };
  const addNewAccount = (values) => {
    const { accountName, accountNumber, ...subOwnersData } = values;
    let id = bankBalanceList.length;
    let newAccount = {
      id,
      accountName,
      accountNumber,
      ownersData: [subOwnersData],
    };
    setBankBalanceList((prevList) => [...prevList, newAccount]);
    setNewAccountFlag(false);
  };
  const addSubOwnersData = (values, accountTypeId, selectedSubOwnerIndex) => {
    const { accountName, accountNumber, ...subOwnersData } = values;
    let updatedBankBalanceList = bankBalanceList.map((el) => {
      if (el.id === accountTypeId) {
        el.accountName = accountName;
        el.accountNumber = accountNumber;
        if (selectedSubOwnerIndex || selectedSubOwnerIndex === 0) {
          el.ownersData[selectedSubOwnerIndex] = subOwnersData;
        } else {
          el.ownersData.push(subOwnersData);
        }
      }
      return el;
    });
    setBankBalanceList(updatedBankBalanceList);
    reInitializeSelection();
  };
  const deleteSubOwnersData = (accountTypeId, selectedSubOwnerIndex) => {
    let updatedBankBalanceList;
    if (selectedSubOwnerIndex === 0) {
      updatedBankBalanceList = bankBalanceList.filter(
        (el) => el.id !== accountTypeId
      );
    } else {
      updatedBankBalanceList = bankBalanceList.map((el) => {
        if (el.id === accountTypeId) {
          if (selectedSubOwnerIndex || selectedSubOwnerIndex === 0) {
            el.ownersData.splice(selectedSubOwnerIndex, 1);
          }
        }
        return el;
      });
    }
    setBankBalanceList(updatedBankBalanceList);
    handleBankBalanceModalClose();
    reInitializeSelection();
  };

  const totalBankBalance = () => {
    let count = 0;
    bankBalanceList.forEach(
      (el) => (count += +el.ownersData[0]?.accountBalance)
    );
    return count.toLocaleString("de-DE");
  };

  const handleBankBalanceModalOpen = () => {
    setShowBankBalanceModal(true);
  };
  const handleBankBalanceModalClose = () => {
    setShowBankBalanceModal(false);
    setNewAccountFlag(false);
    reInitializeSelection();
  };

  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: clientId,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(clientId, boaUserMediaFileId);
    if (result?.success) {
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
    }
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);

  return (
    <React.Fragment>
      <Toaster />
      {showBankBalanceModal && (
        <BankBalanceModal
          open={showBankBalanceModal}
          handleOpen={() => handleBankBalanceModalOpen()}
          handleClose={() => handleBankBalanceModalClose()}
          newAccountFlag={newAccountFlag}
          focusedFeild={focusedFeild}
          accountTypeId={accountTypeId}
          selectedSubOwner={selectedSubOwner}
          selectedSubOwnerIndex={selectedSubOwnerIndex}
          addSubOwnersData={addSubOwnersData}
          addNewAccount={addNewAccount}
        />
      )}
      <DeleteDataModal
        open={deleteDataModal}
        handleClose={() => {
          setDeleteDataModal(false);
        }}
        accountTypeId={accountTypeId}
        selectedSubOwnerIndex={selectedSubOwnerIndex}
        deleteData={deleteSubOwnersData}
        user={focusedFeild.accountName}
      />
      <Box className="bank-balances-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <SecondaryButton
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: "1.5rem",
                      position: "absolute",
                      top: "-1px",
                      left: "7%",
                    }}
                  >
                    +
                  </Typography>{" "}
                  {t("add-account")}
                </>
              }
              textTransform="initial"
              fontWeight="normal"
              bgColor="color.magentaLight2"
              borderRadius="40px"
              padding="2px auto"
              minWidth="235px"
              marginLeft="20px"
              border="none"
              hoverBgColor="color.magentaLight1"
              click={() => handleAddNewAccount()}
            />
            <ImportData
              sectionId={2}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{ "th , td": { border: "none" } }}
              aria-label="sticky table"
              stickyHeader
            >
              <TableHead stickyHeader>
                <TableRow>
                  <TableCell align="left">{t("bb-table-heading-1")} </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-1")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-2")}
                  </TableCell>
                  <TableCell align="left">{t("bb-table-heading-2")}</TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-3")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bankBalanceList.map((item, index) => {
                  return (
                    <React.Fragment key={item.id}>
                      {item.ownersData?.length > 0 ? (
                        item.ownersData.map((subOwner, subOwnerIndex, arr) => {
                          return (
                            <TableRow
                              sx={{
                                backgroundColor: `${
                                  index % 2 === 0
                                    ? "color.smokeWhite"
                                    : "color.white"
                                }`,
                              }}
                              key={subOwner?.id}
                              className={
                                updatedIds.includes(item?.id) ||
                                updatedIds.includes(subOwner?.id)
                                  ? "highlighted-table-row"
                                  : ""
                              }
                            >
                              <TableCell>
                                {subOwnerIndex === 0 ? item.accountName : null}
                                <Typography variant="caption" display="block">
                                  {subOwnerIndex === 0
                                    ? item.accountNumber ||
                                      ""
                                    : null}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "21px 8px",
                                  }}
                                >
                                  <Box>{`${
                                    subOwner?.nameOfOwner
                                      ? subOwner.nameOfOwner
                                      : "-"
                                  }`}</Box>
                                  {subOwnerIndex === 0 ? (
                                    <IconButton
                                      sx={{
                                        cursor: "pointer",
                                      }}
                                      aria-label="Add"
                                      size="small"
                                      onClick={() =>
                                        handleAddSubOwner(item, item.id)
                                      }
                                    >
                                      <AddCircleOutlineSharpIcon />
                                    </IconButton>
                                  ) : null}
                                </Box>
                              </TableCell>
                              <TableCell>{`${
                                subOwner?.ownerShipPercentage
                                  ? subOwner.ownerShipPercentage + "%"
                                  : "-"
                              }`}</TableCell>
                              <TableCell>{`${
                                subOwner?.accountBalance
                                  ? Number(
                                      subOwner.accountBalance
                                    ).toLocaleString("de-DE") + " €"
                                  : "-"
                              }`}</TableCell>
                              <TableCell>
                                <FormattedDate
                                  date={subOwner.date}
                                  language={i18n.language}
                                />
                              </TableCell>

                              <TableCell>
                                <IconButton
                                  sx={{ cursor: "pointer" }}
                                  aria-label="add"
                                  size="small"
                                  onClick={() =>
                                    handleAddSubOwner(
                                      item,
                                      item.id,
                                      subOwner,
                                      subOwnerIndex
                                    )
                                  }
                                >
                                  <img
                                    src="/assets/icons/edit-icon.svg"
                                    alt="edit"
                                  />
                                </IconButton>
                                <IconButton
                                  sx={{ cursor: "pointer" }}
                                  aria-label="delete"
                                  size="small"
                                  onClick={() =>
                                    handleDeleteSubOwner(
                                      item,
                                      item.id,
                                      subOwner,
                                      subOwnerIndex
                                    )
                                  }
                                >
                                  <img
                                    src="/assets/icons/delete-icon.svg"
                                    alt="delete"
                                  />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow
                          sx={{
                            backgroundColor: `${
                              index % 2 === 0
                                ? "color.smokeWhite"
                                : "color.white"
                            }`,
                          }}
                        >
                          <TableCell>{item.accountName}</TableCell>
                          <TableCell>-</TableCell>
                          <TableCell>-</TableCell>
                          <TableCell>-</TableCell>
                          <TableCell>-</TableCell>
                          <TableCell align="right">
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="add"
                              size="small"
                              onClick={() => handleAddSubOwner(item, item.id)}
                            >
                              <img
                                src="/assets/icons/edit-icon.svg"
                                alt="edit"
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  );
                })}

                <TableRow sx={{ backgroundColor: "#DFC8DB !important" }}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right">{t("total")}</TableCell>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                  >{` ${totalBankBalance()} € `}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* </SimpleBarReact> */}
        </Box>

        <Box
          className="save-countinue-btn"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={handleFinalSubmit}
            textTransform="initial"
            disabled={btnLoading}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}

      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </React.Fragment>
  );
};

export default Summary;
